// extracted by mini-css-extract-plugin
module.exports = {"hidden":"styles_hidden__kItZE","desktop":"styles_desktop__5lwoj","mobile":"styles_mobile__cHBkJ","tablet":"styles_tablet__GWwKk","responsive":"styles_responsive__3EsOT"};